import React from 'react'
import { FilterParam, FilterName } from '../FilterBar.types'
import { GenericFilterDropdown } from './GenericFilterDropdown'

interface EmailNotificationFilterDropdownProps {
  isNested?: boolean
}

export const EmailNotificationFilterDropdown: React.FC<
  EmailNotificationFilterDropdownProps
> = ({ isNested }) => {
  return (
    <GenericFilterDropdown
      filterParam={FilterParam.EMAIL_NOTIFICATION}
      filterName={FilterName.EMAIL_NOTIFICATION}
      valueKey="emailNotifications"
      isNested={isNested}
    />
  )
}
